import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {NookalPrepareIntegrationRequestDto} from '../../dtos/nookalPrepareIntegrationRequest.dto';

@Injectable({
    providedIn: 'root'
})
export class NookalAdminService {

    constructor(private _httpClient: HttpClient) {}

    /**
     * Approves the integration and triggers the first import of the account's Nookal participants.
     * Requires the ADMIN role on the server.
     */
    public prepareIntegration(prepareIntegrationDto: NookalPrepareIntegrationRequestDto): Observable<void> {
        return this._httpClient.post<any>(environment.apiUrl + 'api/integration/nookal/admin/v1/prepareIntegration',
            prepareIntegrationDto);
    }
}
